<template>
    <div class="batch-multiple-oppo-pages">
        <div v-if="isPageAllowed">
            <div class="tab-bar relative">
                <el-tabs :value="batch" @tab-click="changeTab" style="background-color:#FFFFFF;">
                    <el-tab-pane label="批量创建" name="oppo_batch_create" v-if="getActionNames('oppo_batch_create')"></el-tab-pane>
                    <el-tab-pane label="计划复制" name="oppo_plan_copy" v-if="getActionNames('oppo_plan_copy')"></el-tab-pane>
                </el-tabs>
            </div>
        
            <div class="batch-multiple-oppo-pages-content p10">
                <router-view/>
            </div>
        </div>
        
        <template v-else>
            <NoPermissionInfo style="background-color: #fff;">
                <p>此页面展示OPPO媒体相关数据内容与广告管理。</p>
            </NoPermissionInfo>
        </template>
        
    </div>
</template>
<script>
    import { pageMixin } from '@/views/mixins/pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    export default {
        name: "BatchMultipleOppoPages",
        mixins: [pageMixin],
        components: {
            NoPermissionInfo
        },
        data() {
            return {
                batch: 'oppo_batch_create'
            }
        },
        mounted() {
            this.batch = this.$route?.name
            // this.changeTab(this.$route)
            // if(this.$route?.name == 'oppo_batch_create'){
            //     this.$router.push({
            //         name: this.$route?.name,
            //         query: {
            //            ...this.$route.query
            //         }
            //     })
            // }else if(this.$route?.name == 'oppo_plan_copy'){
            //     console.log(this.$route?.name,this.$route.params,222)
            //     this.$router.push({
            //         name: this.$route?.name,
            //         params: {
            //             type: this.$route?.params?.type,
            //         },
            //         query: {
            //            ...this.$route.query
            //         }
            //     })
            // }
        },
        methods: {
            changeTab(val) {
                this.batch = val.name
                this.$router.push({
                    name: val.name,
                    params: {
                        type: 'list'
                    },
                    query: {
                        ...this.$route.query
                    }
                })
            },
            getActionNames(name) {
                return this.pageActionNames.includes(name)
            }
        },
    }
</script>
<style lang="scss" scoped>
.batch-multiple-oppo-pages{
    padding: 0;
    background-color:#F1F4F9;
}
.tab-bar::after{
    content: '';
    position: absolute;
    left: -20px;
    right: -20px;
    background-color: #fff;
}
.tab-bar :deep(.el-tabs__header){
    background-color: #fff;
    margin-bottom: 0px;
    .el-tabs__nav-wrap{
        padding-left: 30px;
    }
    .el-tabs__active-bar {
        min-width: 56px;
    }
}
.tab-bar :deep(.el-tab-pane){
    margin: 0 15px;
}
</style>